
export enum GameModeTranslationKeyContext {
    BaseGame = '',
    Seafarers = 'seafarers',
    CitiesAndKnights = 'c&k',
    CitiesAndKnightsSeafarers = 'c&kSeafarers',
}
